import * as OrderTexts from '../../../../../../intl'
import { form } from '../../../formState'
import { Props } from '../typings'

const NOTES_MAX_LENGTH = 1500

export function Note(props: Props) {
  const { orderStepType } = props

  const fieldName = `${orderStepType}.notes` as 'pickup.notes' | 'delivery.notes'

  const { field } = form.useFormField<typeof fieldName>(fieldName)

  form.useAddFieldValidation<typeof fieldName>(fieldName, (field, _formApi) => {
    const notes = field.value

    if (notes && notes.length > NOTES_MAX_LENGTH) {
      return OrderTexts.getValidationErrorMaxLengthText(NOTES_MAX_LENGTH)
    }
  })

  return (
    <form.TextField
      name={`${orderStepType}.notes`}
      label={OrderTexts.geFieldLabelNotesText()}
      testId="note"
      helperText={`${(field.value ?? '').length}/${NOTES_MAX_LENGTH}`}
      debounce={null}
      textfieldProps={{
        multiline: true,
        rows: 5,
        inputProps: { maxLength: NOTES_MAX_LENGTH },
      }}
    />
  )
}
